export const inventoryCards = {
    bomVersionCard: {
        entity: 'bomVersion',
        path: 'product/:id/bomVersion',
        titleBar: { mergeParams: ['version'], new: 'bomVersion.form.new.title' },
        cardTitle: {
            title: 'bomVersion.form.dropdown.toggle',
            buttons: [
                {
                    type: 'submit',
                    id: 'bomVersionCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                { action: 'activate', label: 'bomVersion.form.activate', confirm: true, modalConfig: 'bomVersionConfirmActivate' },
                { action: 'obsolete', label: 'bomVersion.form.obsolete', confirm: true, modalConfig: 'bomVersionConfirmObsolete' },
                { action: 'delete', label: 'bomVersion.form.delete', confirm: true, modalConfig: 'bomVersionConfirmDelete' }
            ],
            actions: {
                activate: { message: 'bomVersion.action.activate.message' },
                obsolete: { message: 'bomVersion.action.obsolete.message' }
            }
        },
        width: '900px',
        sections: [
            {
                id: 'bomVersion',
                meta: { type: 'form', width: '900px' },
                groups: [
                    {
                        type: 'group',
                        id: 'versionStatus',
                        fields: [
                            { type: 'text', id: 'version', label: 'bomVersion.form.version', placeholder: 'bomVersion.form.version.placeholder', required: true },
                            {
                                type: 'switchSelect',
                                id: 'status',
                                displayField: 'statusName',
                                label: 'bomVersion.form.status',
                                entity: 'activeStatus',
                                valueMap: {
                                    'statusName': 'name',
                                    'status': 'id'
                                },
                                readOnly: true
                            }
                        ]
                    },
                    { type: 'textarea', id: 'description', label: 'bomVersion.form.description', rows: 2 },
                    {
                        type: 'group',
                        id: 'effectiveFromTo',
                        fields: [
                            {
                                type: 'date', id: 'effectiveFrom', label: 'bomVersion.form.effectiveFrom', defaultType: 'date',
                            },
                            {
                                type: 'date', id: 'effectiveTo', label: 'bomVersion.form.effectiveTo', defaultType: 'date',
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'yieldQtyScrapPercent',
                        fields: [
                            { type: 'number', id: 'yieldQty', label: 'bomVersion.form.yieldQty', decimals: 4, variant: 'quantity' },
                            { type: 'number', id: 'scrapPercent', label: 'bomVersion.form.scrapPercent', decimals: 2, variant: 'quantity' }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'netGrossCost',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'netCost',
                                label: 'bomVersion.form.net.cost',
                                displayType: 'amount'
                            },
                            {
                                type: 'text-readOnly',
                                id: 'grossCost',
                                label: 'bomVersion.form.gross.cost',
                                displayType: 'amount'
                            }

                        ]
                    },
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'bomVersionCard.bomVersion.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'version',
                    columns: [{
                        weight: 1, basis: '100%',
                        elements: [
                            { type: 'field', value: 'version', scale: 'title' },
                            { type: 'field', value: 'statusName', scale: 'normal' }
                        ]
                    },
                    {
                        weight: 1, basis: '100%',
                        elements: [
                            { type: 'field', value: 'description', scale: 'normal' }
                        ]
                    }]
                }
            },
            {
                id: 'bomVersion.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'bomVersion.form.line.add',
                    width: '900px'
                },
                groups: [
                    {
                        type: 'connect',
                        id: 'productId',
                        displayField: 'productName',
                        label: 'bomVersion.form.line.product',
                        placeholder: 'bomVersion.form.line.product.placeholder',
                        modalTitle: 'bomVersion.form.line.product.modal.title',
                        entity: 'product',
                        valueMap: {
                            'productId': 'id',
                            'productName': 'name',
                            'productSku': 'sku',
                            'uom': 'unitId',
                            'uomName': 'unitName',
                            'productNetSalesPrice': 'netSalesPrice',
                            'productGrossSalesPrice': 'grossSalesPrice',
                            'productTaxRate': 'taxRate'
                        },
                        options: { withHeaders: true },
                        required: true,
                        manualEntry: false
                    },
                    {
                        type: 'group',
                        id: 'qtyUomScrapPercent',
                        fields: [
                            {
                                type: 'number',
                                id: 'qty',
                                label: 'bomVersion.form.line.qty',
                                placeholder: 'bomVersion.form.line.qty.placeholder',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'uom',
                                displayField: 'uomName',
                                label: 'bomVersion.form.line.uom',
                                placeholder: 'bomVersion.form.line.uom.placeholder',
                                entity: 'unit',
                                valueMap: { 'uom': 'id', 'uomName': 'name' },
                                options: { withHeaders: true },
                                required: true
                            },
                            {
                                type: 'number',
                                id: 'scrapPercent',
                                label: 'bomVersion.form.line.scrapPercent',
                                decimals: 2,
                                defaultType: 'value',
                                defaultValue: 0,
                                variant: 'quantity'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        id: 'notes',
                        label: 'bomVersion.form.line.notes',
                        placeholder: 'bomVersion.form.line.notes.placeholder'
                    }
                ],
                buttons: [
                    { type: 'button', id: 'bomVersionCard.lines.delete', action: 'delete', label: 'all.form.button.delete', icon: 'delete', variant: 'danger', size: 'icon' },
                    { type: 'button', id: 'bomVersionCard.lines.close', action: 'close', label: 'all.form.button.save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'productName',
                    emptyMessage: 'bomVersion.form.line.product.missing',
                    editButtonRightOffset: '30%',
                    columns: [
                        { weight: 3, basis: '40%', elements: [{ type: 'field', value: 'productName', scale: 'title' }, { type: 'field', value: 'productSku', scale: 'normal' }] },
                        { weight: 2, basis: '20%', elements: [{ type: 'merge', value: '${1} ${2}', mergeParams: ['qty', 'uomName'], scale: 'normal' }] },
                        { weight: 1, basis: '15%', elements: [{ type: 'field', value: 'scrapPercent', scale: 'normal' }] }
                    ]
                }
            }
        ]
    },

    hallCard: {
        entity: 'hall',
        path: 'warehouse/:id/hall',
        titleBar: { mergeParams: ['name'], new: 'hall.form.new.title' },
        cardTitle: {
            title: 'warehouse.hall.list.table.title',
            menuItems: [
                {
                    action: 'delete',
                    label: 'warehouse.hall.list.table.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        sections: [
            {
                id: 'hall',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'text',
                        id: 'name',
                        label: 'hall.form.name',
                        placeholder: 'hall.form.name.placeholder',
                        required: true,
                        autoComplete: 'hall-name'
                    },
                    {
                        type: 'code',
                        id: 'code',
                        label: 'hall.form.name.code',
                        placeholder: 'hall.form.name.code.placeholder',
                        required: true,
                        // Identity — immutable after creation (see halls schema
                        // immutables). To change it, delete + recreate.
                        lockOnEdit: true,
                        autoComplete: 'hall-code'
                    },
                    {
                        type: 'switch',
                        id: 'isArea',
                        label: 'hall.form.isArea'
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'hallCard.hall.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    emptyMessage: 'warehouse.hall.list.table.name.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                }
                            ]
                        }
                    ]
                }
            }]
    },

    inventorySettingsCard: {
        entity: 'inventorySettings',
        path: 'inventorySettings',
        titleBar: { label: 'inventory.settings.heading', mergeParams: ['settingsType'], new: 'inventory.settings.title' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    type: 'submit',
                    id: 'inventorySettingsCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ]
        },
        width: '756px',
        afterSubmit: { stay: true },
        sections: [
            // The module's number series (37.03) — see salesSettingsCard.
            {
                id: 'inventorySettings.numberSeries',
                meta: {
                    type: 'lines',
                    linesArray: 'numberSeries',
                    showAddLine: false,
                    sectionTitle: 'settings.numberSeries.title',
                    width: '756px'
                },
                groups: [
                    { type: 'text-readOnly', id: 'format', label: 'settings.numberSeries.format' },
                    { type: 'text-readOnly', id: 'lastValue', label: 'settings.numberSeries.lastValue' },
                    { type: 'nserie', id: 'nextValue', label: 'settings.numberSeries.nextValue', placeholder: 'settings.numberSeries.nextValue.placeholder', required: true }
                ],
                buttons: [
                    { type: 'submit', id: 'inventorySettingsCard.numberSeries.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'nextValue',
                    emptyMessage: 'settings.numberSeries.empty',
                    columns: [
                        {
                            weight: 6, basis: '60%',
                            elements: [
                                { type: 'merge', value: '${1}', mergeParams: [{ type: 'translate', value: 'labelKey' }], scale: 'title' },
                                { type: 'field', value: 'format', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 4, basis: '40%', align: 'end',
                            elements: [
                                { type: 'field', value: 'nextValue', scale: 'title', prefix: 'settings.numberSeries.next.prefix' },
                                { type: 'field', value: 'lastValue', scale: 'normal', prefix: 'settings.numberSeries.last.prefix', condition: { field: 'lastValue', operator: 'notEmpty' } }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    itemPriceCard: {
        entity: 'itemPrice',
        path: 'product/:id/itemPrice',
        titleBar: { mergeParams: ['code'], new: 'product.price.form.new.title' },
        cardTitle: {
            title: 'warehouse.hall.list.table.title',
            menuItems: [
                {
                    action: 'delete',
                    label: 'warehouse.hall.list.table.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        fieldsLogic: ['typeId', 'value'],
        defaultData: [
            {
                id: 'exchangeRate',
                defaultType: 'value',
                defaultValue: 1
            }
        ],
        sections: [
            {
                id: 'itemPrice',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'typeIdCode',
                        fields: [
                            {
                                type: 'select',
                                id: 'typeId',
                                displayField: 'typeName',
                                label: 'product.price.form.type',
                                placeholder: 'product.price.form.type.placeholder',
                                entity: 'priceType',
                                valueMap: {
                                    'typeName': 'name',
                                    'typeId': 'id'
                                },
                                options: { withHeaders: false },
                                required: true,
                                linkedFields: ['code', 'codeName', 'value', 'typeId']
                            },
                            {
                                type: "currency",
                                id: 'code',
                                displayField: 'code',
                                parameter: "date",
                                label: 'product.price.form.code.valuta',
                                placeholder: 'product.price.form.code.placeholder',
                                modalTitle: "product.price.form.currency.modal.title",
                                entity: 'currency',
                                valueMap: {
                                    'currency': 'id',
                                    'currencyName': 'name',
                                    'exchangeRate': 'exchangeRate',
                                    'code': 'id',
                                    'codeName': 'name'
                                },
                                options: { withHeaders: false, displayId: true },
                                required: true,
                                // One field bound to `code`, rendered as three different
                                // controls depending on what the price is scoped to. The
                                // currency variant is the base because it is the only one
                                // needing an exchange rate; the other two are deltas.
                                condition: { field: 'typeId', operator: 'in', value: ['currency', 'customerGroup', 'campaign'] },
                                conditionals: [
                                    {
                                        condition: { field: 'typeId', operator: 'equals', value: 'customerGroup' },
                                        set: {
                                            type: 'connect',
                                            label: 'product.price.form.code.customerGroup',
                                            placeholder: 'product.price.form.code.customerGroup.placeholder',
                                            entity: 'customerGroup',
                                            valueMap: { 'code': 'code', 'codeName': 'name' },
                                            options: { withHeaders: true },
                                            autoComplete: 'price-code-customerGroup'
                                        },
                                        unset: ['parameter', 'modalTitle']
                                    },
                                    {
                                        condition: { field: 'typeId', operator: 'equals', value: 'campaign' },
                                        set: {
                                            type: 'connect',
                                            label: 'product.price.form.code.campaign',
                                            placeholder: 'product.price.form.code.campaign.placeholder',
                                            entity: 'campaign',
                                            valueMap: { 'code': 'code', 'codeName': 'name' },
                                            options: { withHeaders: true },
                                            autoComplete: 'price-code-campaign'
                                        },
                                        unset: ['parameter', 'modalTitle']
                                    }
                                ],
                                autoComplete: 'price-code-currency'
                            },
                        ]
                    },
                    {
                        type: 'description',
                        id: 'originalPrice',
                        label: 'product.price.form.originalPrice',
                        text: 'product.price.form.code.description',
                        condition: { field: 'typeId', operator: 'equals', value: 'currency' },
                        linkedFields: ['netSalesPrice', 'exchangeRate', 'currency', 'originalPrice'],
                        calculatedFields: [
                            { field: 'convertedAmount', formula: 'originalPrice*exchangeRate' }
                        ],
                        mergeParams: ['currency', 'convertedAmount']
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'group',
                        id: 'modeIdValue',
                        fields: [
                            {
                                type: 'select',
                                id: 'modeId',
                                displayField: 'modeName',
                                label: 'product.price.form.mode',
                                placeholder: 'product.price.form.mode.placeholder',
                                entity: 'priceMode',
                                valueMap: {
                                    'modeName': 'name',
                                    'modeId': 'id'
                                },
                                options: { withHeaders: false },
                                required: true
                            },
                            {
                                type: 'number',
                                id: 'value',
                                label: 'product.price.form.value',
                                placeholder: 'product.price.form.value.placeholder',
                                required: true,
                                decimals: 2,
                                linkedFields: ['originalPrice', 'modeId'],
                                autoComplete: 'price-value'
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'netSalesPriceCurrency',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'netSalesPrice',
                                label: 'product.price.form.price',
                                placeholder: 'product.price.form.price.placeholder',
                                required: true,
                            },
                            {
                                type: "currency",
                                id: "currency",
                                displayField: "currency",
                                parameter: "date",
                                label: "product.price.form.currency",
                                placeholder: "product.price.form.currency.placeholder",
                                modalTitle: "product.price.form.currency.modal.title",
                                entity: "currency",
                                valueMap: {
                                    currency: "id",
                                    currencyName: "name",
                                    exchangeRate: "exchangeRate",
                                },
                                options: { withHeaders: true, displayId: true },
                                required: true,
                                // Shown for the two scoped price types, hidden for 'currency'
                                // itself. This was two elements with opposite NEGATIVE tests,
                                // which rendered the control twice when typeId was 'currency'.
                                condition: { field: 'typeId', operator: 'in', value: ['campaign', 'customerGroup'] }
                            },
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'itemPriceCard.itemPrice.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'code',
                    emptyMessage: 'product.price.form.code.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'codeName',
                                    scale: 'title'
                                }
                            ]
                        }
                    ]
                }
            }]
    },

    locationCard: {
        entity: 'location',
        path: 'location',
        titleBar: { mergeParams: ['id'], new: 'location.form.new.title' },
        cardTitle: {
            title: 'rack.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'rack.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }
            ]
        },
        sections: [
            {
                id: 'location',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'warehouseHallRackCode',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'warehouseCode',
                                label: 'location.form.warehouseCode',
                                placeholder: 'location.form.warehouseCode.placeholder',
                                required: true,
                            },
                            {
                                type: 'text-readOnly',
                                id: 'hallCode',
                                label: 'location.form.hallCode',
                                placeholder: 'location.form.hallCode.placeholder',
                                required: true,
                                condition: { field: 'hallCode', operator: 'notEmpty' }
                            },
                            {
                                type: 'text-readOnly',
                                id: 'rackCode',
                                label: 'location.form.rackCode',
                                placeholder: 'location.form.rackCode.placeholder',
                                required: true,
                            },
                        ]
                    },
                    {
                        type: 'group',
                        id: 'levelPosition',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'level',
                                label: 'location.form.level',
                                placeholder: 'location.form.level.placeholder',
                                required: true,
                            },
                            {
                                type: 'text-readOnly',
                                id: 'position',
                                label: 'location.form.position',
                                placeholder: 'location.form.position.placeholder',
                                required: true,
                                condition: { field: 'position', operator: 'notEmpty' }
                            },
                                                    ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'locationCard.location.close',
                        action: 'close',
                        label: 'all.form.button.close',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'id',
                    emptyMessage: 'rack.form.name.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'id',
                                    scale: 'title'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    productCard: {
        entity: 'product',
        path: 'product',
        titleBar: { mergeParams: ['name'], new: 'product.form.new.title' },
        cardTitle: {
            title: 'product.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'product.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'productConfirmDelete'

                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        width: '768px',
        fieldsLogic: ['netSalesPrice', 'grossSalesPrice', 'taxId'],
        sections: [
            {
                id: 'product',
                meta: {
                    type: 'form',
                    width: '768px'
                },
                groups: [
                    {
                        type: 'text',
                        id: 'name',
                        label: 'product.form.name',
                        placeholder: 'product.form.name.placeholder',
                        required: true,
                        linkedFields: ['name', 'sku']
                    },
                    {
                        type: 'text',
                        id: 'sku',
                        label: 'product.form.sku',
                        placeholder: 'product.form.sku.placeholder',
                        required: true
                    },
                    {
                        type: 'textarea',
                        id: 'description',
                        label: 'product.form.description',
                        placeholder: 'product.form.description.placeholder',
                        required: true,

                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'netGrossSalesPrice',
                        fields: [
                            {
                                type: 'number',
                                id: 'netSalesPrice',
                                label: 'product.form.netSalesPrice',
                                placeholder: 'product.form.netSalesPrice.placeholder',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                linkedFields: ['netSalesPrice', 'taxRate'],
                                variant: 'price'
                            },
                            {
                                type: 'number',
                                id: 'grossSalesPrice',
                                label: 'product.form.grossSalesPrice',
                                placeholder: 'product.form.grossSalesPrice.placeholder',
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                linkedFields: ['grossSalesPrice', 'taxRate'],
                                variant: 'price'
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'unitTaxId',
                        fields: [
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'product.form.unitName',
                                placeholder: 'product.form.unitName.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'unitName': 'name',
                                    'unitId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true
                            },
                            {
                                type: 'select',
                                id: 'taxId',
                                displayField: 'taxName',
                                label: 'product.form.vatTax',
                                placeholder: 'product.form.unitName.placeholder',
                                entity: 'vatTax',
                                entityParams: {
                                    type: 'query',
                                    params: [
                                        { key: 'scope', value: 'sales' },
                                        { key: 'productType', value: '${type}' }
                                    ]
                                },
                                valueMap: {
                                    'taxName': 'name',
                                    'taxId': 'id',
                                    'taxRate': 'rate'
                                },
                                // A code without a rate of its own (OSS) writes null, not the previous code's rate.
                                nullDefaults: { taxRate: null },
                                options: { withHeaders: false },
                                required: true,
                                linkedFields: ['type']
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'typeTotalInventory',
                        fields: [
                            {
                                type: 'select',
                                id: 'type',
                                displayField: 'typeName',
                                label: 'product.form.type',
                                placeholder: 'product.form.type.placeholder',
                                entity: 'productType',
                                valueMap: { 'type': 'id', 'typeName': 'name' },
                                options: { withHeaders: false }
                            },
                            {
                                type: 'text-readOnly',
                                id: 'totalInventory',
                                label: 'product.form.total.inventory',
                                displayType: 'quantity'
                            }
                        ]
                    },
                    {
                        type: 'modal',
                        id: 'productAttributesModal',
                        control: {
                            type: 'text',
                            id: 'productAttributes',
                            label: 'product.form.attributes',
                            placeholder: 'product.form.attributes.placeholder'
                        },
                        descriptions: [
                            {
                                type: 'label',
                                text: 'product.form.attributes.label.group'
                            },
                            {
                                type: 'field',
                                field: 'productGroup'
                            },
                            {
                                type: 'label',
                                text: ' - '
                            },
                            {
                                type: 'label',
                                text: 'product.form.attributes.label.unitCost'
                            },
                            {
                                type: 'field',
                                field: 'unitCost'
                            },
                            {
                                type: 'label',
                                text: ' - '
                            },
                            {
                                type: 'label',
                                text: 'product.form.attributes.label.isBom'
                            },
                            {
                                type: 'field',
                                field: 'isBom'
                            }
                        ],
                        modalForm: {
                            id: 'productAttributes',
                            elements: [
                                {
                                    type: 'hconnect',
                                    id: 'productGroup',
                                    displayField: 'productGroup',
                                    parentId: 'parentId',
                                    label: 'product.form.attributes.productGroup',
                                    placeholder: 'product.form.attributes.productGroup.placeholder',
                                    modalTitle: "product.form.attributes.productGroup.modal.title",
                                    entity: 'productGroup',
                                    parentField: { field: 'type', value: 'normal' },
                                    valueMap: {
                                        'productGroup': 'id',
                                    },
                                    options: { withHeaders: true },
                                    required: true,
                                    linkedFields: ['productGroup']
                                },
                                {
                                    type: 'connect',
                                    id: 'supplierId',
                                    displayField: 'supplierName',
                                    label: 'product.form.attributes.supplier',
                                    placeholder: 'product.form.attributes.supplier.placeholder',
                                    modalTitle: 'product.form.attributes.supplier.modal.title',
                                    entity: 'contact',
                                    entityParams: {
                                        type: 'filter',
                                        filters: [{ key: 'contactType', value: 'supplier|both' }]
                                    },
                                    valueMap: {
                                        'supplierId': 'id',
                                        'supplierName': 'name'
                                    },
                                    options: { withHeaders: true },
                                    condition: { field: 'type', operator: 'equals', value: 'purchased' }
                                },
                                {
                                    type: 'number',
                                    id: 'unitCost',
                                    label: 'product.form.attributes.unitCost',
                                    placeholder: 'product.form.attributes.unitCost.placeholder',
                                    decimals: 2,
                                    variant: 'price'
                                },
                                {
                                    type: 'text',
                                    id: 'barcode',
                                    label: 'product.form.barcode',
                                    placeholder: 'product.form.barcode.placeholder'
                                },
                                {
                                    type: 'switch',
                                    id: 'isBom',
                                    label: 'product.form.isBom',
                                    options: [
                                        { value: true, label: 'product.form.isBom.yes' },
                                        { value: false, label: 'product.form.isBom.no' }
                                    ]
                                },
                            ]
                        }
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'productCard.product.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary',
                        invalidateQuery: 'product'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    emptyMessage: 'product.form.name.missing.message',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'normal'
                                }
                            ],
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} DKK',
                                    mergeParams: ['netSalesPrice'],
                                    scale: 'title'
                                },
                                {
                                    type: 'merge',
                                    value: '@${1}',
                                    mergeParams: ['unitName'],
                                    scale: 'normal'
                                },

                            ]
                        }
                    ]

                }
            },
        ]
    },

    productFamilyCard: {
        entity: 'productFamily',
        path: 'productFamily',
        titleBar: { mergeParams: ['name'], new: 'productFamily.form.new.title' },
        cardTitle: {
            title: 'productFamily.form.dropdown.toggle',
            buttons: [
                { type: 'submit', id: 'productFamilyCard.save', action: 'save', label: 'all.form.button.save', icon: 'save', variant: 'primary' }
            ],
            menuItems: [
                { action: 'delete', label: 'productFamily.form.delete', confirm: true, modalConfig: 'productFamilyConfirmDelete' },
                { action: 'generateVariants', label: 'productFamily.form.generateVariants', confirm: true, modalConfig: 'productFamilyConfirmGenerateVariants' }
            ]
        },
        width: '768px',
        fieldsLogic: ['netSalesPrice', 'grossSalesPrice', 'taxId'],
        sections: [
            {
                id: 'productFamily',
                meta: { type: 'form', width: '768px' },
                groups: [
                    { type: 'text', id: 'name', label: 'productFamily.form.name', placeholder: 'productFamily.form.name.placeholder', required: true, linkedFields: ['name', 'sku'] },
                    { type: 'text', id: 'sku', label: 'productFamily.form.sku', placeholder: 'productFamily.form.sku.placeholder', required: true },
                    { type: 'textarea', id: 'description', label: 'productFamily.form.description', rows: 2 },
                    {
                        type: 'group',
                        id: 'netGrossSalesPrice',
                        fields: [
                            {
                                type: 'number',
                                id: 'netSalesPrice',
                                label: 'productFamily.form.netSalesPrice',
                                placeholder: 'productFamily.form.netSalesPrice.placeholder',
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 0,
                                linkedFields: ['netSalesPrice', 'taxRate'],
                                variant: 'price'
                            },
                            {
                                type: 'number',
                                id: 'grossSalesPrice',
                                label: 'productFamily.form.grossSalesPrice',
                                placeholder: 'productFamily.form.grossSalesPrice.placeholder',
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 0,
                                linkedFields: ['grossSalesPrice', 'taxRate'],
                                variant: 'price'
                            }
                        ]
                    },
                    {
                        type: 'select',
                        id: 'unitId',
                        displayField: 'unitName',
                        label: 'productFamily.form.unitName',
                        placeholder: 'productFamily.form.unitName.placeholder',
                        entity: 'unit',
                        valueMap: { 'unitName': 'name', 'unitId': 'id' },
                        options: { withHeaders: true },
                        required: true
                    },
                    {
                        type: 'select',
                        id: 'taxId',
                        displayField: 'taxName',
                        label: 'productFamily.form.vatTax',
                        placeholder: 'productFamily.form.vatTax.placeholder',
                        entity: 'vatTax',
                        entityParams: {
                            type: 'query',
                            params: [
                                { key: 'scope', value: 'sales' }
                            ]
                        },
                        valueMap: { 'taxName': 'name', 'taxId': 'id', 'taxRate': 'rate' },
                        // A code without a rate of its own (OSS) writes null, not the previous code's rate.
                        nullDefaults: { taxRate: null },
                        options: { withHeaders: false },
                        required: true
                    },
                ],
                buttons: [
                    { type: 'button', id: 'productFamilyCard.productFamily.close', action: 'close', label: 'all.form.button.update', icon: 'save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        {
                            weight: 7, basis: '70%',
                            elements: [
                                { type: 'field', value: 'name', scale: 'title' },
                                { type: 'field', value: 'description', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 3, basis: '30%', align: 'end',
                            elements: [
                                { type: 'merge', value: '${1}', mergeParams: ['netSalesPrice'], scale: 'title' },
                                { type: 'merge', value: '@${1}', mergeParams: ['unitName'], scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'productFamily.dimensions',
                meta: {
                    type: 'lines',
                    linesArray: 'dimensions',
                    linesAddAction: 'productFamily.form.dimension.add',
                    width: '768px'
                },
                groups: [
                    {
                        type: 'text',
                        id: 'name',
                        label: 'productFamily.form.dimension.name',
                        placeholder: 'productFamily.form.dimension.name.placeholder',
                        required: true
                    },
                    {
                        type: 'arrayModal',
                        id: 'values',
                        displayField: 'name',
                        label: 'productFamily.form.dimension.values',
                        modalTitle: 'productFamily.form.dimension.values.modal.title',
                        addLabel: 'productFamily.form.dimension.value.add',
                        columns: [
                            { type: 'text', id: 'name', label: 'productFamily.form.dimension.value.name', required: true, slugTarget: { field: 'code', maxLength: 5 } },
                            { type: 'text', id: 'code', label: 'productFamily.form.dimension.value.code', required: true }
                        ]
                    }
                ],
                buttons: [
                    { type: 'button', id: 'productFamilyCard.dimensions.delete', action: 'delete', label: 'all.form.button.delete', icon: 'delete', variant: 'danger', size: 'icon' },
                    { type: 'button', id: 'productFamilyCard.dimensions.save', action: 'save', label: 'all.form.button.save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'name',
                    emptyMessage: 'productFamily.form.dimension.name.missing',
                    editButtonRightOffset: '30%',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                { type: 'field', value: 'name', scale: 'title' },
                                { type: 'arrayField', value: 'values', scale: 'normal', displayField: 'name', separator: ' · ' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    productGroupCard: {
        entity: 'productGroup',
        path: 'productGroup',
        titleBar: { mergeParams: ['id'], new: 'productGroup.form.new.title' },
        cardTitle: {
            title: 'productGroup.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'productGroup.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }
            ]
        },
        width: '1024px',
        sections: [
            {
                id: 'productGroup',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'code',
                        id: 'id',
                        label: 'productGroup.form.code',
                        placeholder: 'productGroup.form.code.placeholder',
                        required: true,
                        maxLen: 100,
                        // Editable on create, read-only once it is the record's identity.
                        condition: { field: '$mode', operator: 'in', value: ['new', 'edit'] },
                        conditionals: [
                            {
                                condition: { field: '$mode', operator: 'equals', value: 'edit' },
                                set: { type: 'text-readOnly' },
                                unset: ['maxLen']
                            }
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'description',
                        label: 'productGroup.form.description',
                        placeholder: 'productGroup.form.description.placeholder',
                        rows: 2
                    },
                    {
                        type: 'switchSelect',
                        id: 'type',
                        displayField: 'typeName',
                        label: 'productGroup.form.type',
                        entity: 'groupType',
                        valueMap: {
                            'typeName': 'name',
                            'type': 'id'
                        }
                    },
                    {
                        type: 'connect',
                        id: 'parentId',
                        displayField: 'parentId',
                        label: 'productGroup.form.parentId',
                        placeholder: 'productGroup.form.parentId.placeholder',
                        modalTitle: "productGroup.form.parentId.modal.title",
                        entity: 'productGroup',
                        entityParams: {
                            type: 'filter',
                            filters: [{ key: 'type', value: 'normal' }]
                        },
                        valueMap: {
                            'parentId': 'id',
                        },
                        options: { withHeaders: true },
                        required: true,
                        condition: { field: 'type', operator: 'equals', value: 'subGroup' },
                        linkedFields: ['type']

                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'productGroupCard.productGroup.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'id',
                    emptyMessage: 'productGroup.form.name.missing.message',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'merge',
                                    value: 'Code: ${1}',
                                    mergeParams: ['id'],
                                    scale: 'title'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    rackCard: {
        entity: 'rack',
        path: 'rack',
        titleBar: { mergeParams: ['code'], new: 'rack.form.new.title' },
        cardTitle: {
            title: 'rack.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'rack.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        sections: [
            {
                id: 'rack',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        // Rack Code + Rack Type on one line (manual racks only).
                        type: 'group',
                        id: 'codeKind',
                        condition: { field: 'workCenterId', operator: 'in', value: ['', null, undefined] },
                        fields: [
                            {
                                type: 'code',
                                id: 'code',
                                label: 'rack.form.code',
                                placeholder: 'rack.form.code.placeholder',
                                required: true,
                                maxLen: 5,
                                // Identity — immutable after creation (racks schema
                                // immutables). To change it, delete + recreate. (28.06 WP-11)
                                lockOnEdit: true,
                                autoComplete: 'rack-code'
                            },
                            {
                                // Rack type (28.06 E2): STORAGE = totalLevels x
                                // totalPositions numeric grid; CUSTOM = explicit position
                                // lines below. Work-center footprints (kind WORKCENTER)
                                // are auto-generated and never shown this selector.
                                type: 'switchSelect',
                                id: 'kind',
                                displayField: 'kindName',
                                label: 'rack.form.kind',
                                entity: 'rackKind',
                                valueMap: { 'kind': 'id', 'kindName': 'name' },
                            }
                        ]
                    },
                    {
                        type: 'text-readOnly',
                        id: 'code',
                        label: 'rack.form.code',
                        condition: { field: 'workCenterId', operator: 'notIn', value: ['', null, undefined] }
                    },
                    {
                        type: 'dualconnect',
                        id: 'warehouseId',
                        displayField: 'warehouseName',
                        label: 'rack.form.warehouseName',
                        placeholder: 'rack.form.warehouseName.placeholder',
                        modalTitle: 'rack.form.warehouse.modal.title',
                        entity: 'warehouse',
                        valueMap: {
                            'warehouseName': 'name',
                            'warehouseId': 'id',
                            'warehouseCode': 'code',
                            'useHalls': 'useHalls'
                        },
                        options: { withHeaders: false },
                        required: true,
                        showSubField: { field: 'useHalls', value: true },
                        sub: {
                            id: 'hallId',
                            displayField: 'hallName',
                            placeholder: 'rack.form.hall.placeholder',
                            modalTitle: 'rack.form.hall.modal.title',
                            entity: 'hall',
                            valueMap: {
                                'hallName': 'name',
                                'hallId': 'id',
                                'hallCode': 'code'
                            }
                        }
                    },
                    {
                        // Grid dimensions — shown only for STORAGE racks (hidden for
                        // CUSTOM racks, whose positions come from the lines section below).
                        type: 'group',
                        id: 'totalLevelsPositions',
                        condition: { field: 'kind', operator: 'in', value: ['STORAGE', '', null, undefined] },
                        fields: [{
                            type: 'number',
                            id: 'totalLevels',
                            label: 'rack.form.totalLevels',
                            placeholder: 'rack.form.totalLevels.placeholder',
                            required: true,
                            decimals: 0,
                            defaultType: 'value',
                            defaultValue: 1,
                            variant: 'quantity'
                        },
                        {
                            type: 'number',
                            id: 'totalPositions',
                            label: 'rack.form.totalPositions',
                            placeholder: 'rack.form.totalPositions.placeholder',
                            required: true,
                            decimals: 0,
                            defaultType: 'value',
                            defaultValue: 1,
                            variant: 'quantity'
                        }]
                    },
                    {
                        type: 'text-readOnly',
                        id: 'calculatedLocations',
                        label: 'rack.form.calculatedLocations',
                        placeholder: 'rack.form.calculatedLocations.placeholder',
                        required: true,
                        defaultType: 'value',
                        defaultValue: '0',
                        condition: { field: 'workCenterId', operator: 'in', value: ['', null, undefined] }
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'rackCard.rack.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    emptyMessage: 'rack.form.name.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                // Custom position lines (28.06 WP-4). Editable list of {code, name};
                // each becomes a drawn location via createRackPositions on save.
                // Shown only for CUSTOM racks (hidden for STORAGE grid racks).
                id: 'rack.positions',
                meta: {
                    type: 'lines',
                    linesArray: 'positions',
                    linesAddAction: 'rack.form.positions.add',
                    condition: { field: 'kind', operator: 'equals', value: 'CUSTOM' },
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'codeName',
                        fields: [
                            {
                                type: 'text',
                                id: 'code',
                                label: 'rack.form.positions.code',
                                placeholder: 'rack.form.positions.code.placeholder',
                                required: true
                            },
                            {
                                type: 'text',
                                id: 'name',
                                label: 'rack.form.positions.name',
                                placeholder: 'rack.form.positions.name.placeholder'
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'rackCard.positions.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'rackCard.positions.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'code',
                    emptyMessage: 'rack.form.positions.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                { type: 'field', value: 'code', scale: 'title' },
                                { type: 'field', value: 'name', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }]
    },

    reservationCard: {
        entity: 'stockReservation',
        path: 'stockReservation',
        titleBar: { mergeParams: ['id'], new: 'reservation.form.new.title', type: 'code7' },
        cardTitle: {
            title: 'rack.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'rack.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }
            ]
        },
        sections: [
            {
                id: 'reservation',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'idLocationIdQuantity',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'id',
                                label: 'reservation.form.id',
                                placeholder: 'location.form.warehouseCode.placeholder',
                                required: true,
                                displayType: 'code7'
                            },
                            {
                                type: 'text-readOnly',
                                id: 'locationId',
                                label: 'reservation.form.location',
                                placeholder: 'location.form.position.placeholder',
                                required: true,
                                condition: { field: 'locationId', operator: 'notEmpty' },
                                action: {
                                    path: '/location/:id',
                                    id: 'fieldValue'
                                }

                            },
                            {
                                type: 'text-readOnly',
                                id: 'quantity',
                                label: 'reservation.form.quantity',
                                placeholder: 'location.form.rackCode.placeholder',
                                required: true,
                            },
                        ]
                    },
                    {
                        type: 'group',
                        id: 'itemNameActiveDocumentDocumentId',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'itemName',
                                valueId: 'itemId',
                                label: 'reservation.form.product',
                                placeholder: 'location.form.level.placeholder',
                                required: true,
                                action: {
                                    path: '/product/:id',
                                    id: 'fieldId'
                                }
                            },
                            {
                                type: 'text-readOnly',
                                id: 'activeDocument',
                                label: 'reservation.form.activeDocument',
                                placeholder: 'location.form.hallCode.placeholder',
                                required: true,
                                condition: { field: 'activeDocument', operator: 'notEmpty' },
                                displayType: 'label'
                            },
                            {
                                type: 'text-readOnly',
                                id: 'documentId',
                                label: 'reservation.form.documentNo',
                                placeholder: 'location.form.position.placeholder',
                                required: true,
                                condition: { field: 'documentId', operator: 'notEmpty' },
                                action: {
                                    id: 'fieldValue',
                                    pathField: 'activeDocument',
                                    pathMap: {
                                        stockShipment: '/shipment/:id',
                                        warehouseOrder: './warehouse/warehouseOrder/:id'
                                    }
                                },
                                displayType: 'code7'
                            },
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'reservationCard.reservation.close',
                        action: 'close',
                        label: 'all.form.button.close',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'id',
                    emptyMessage: 'rack.form.name.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'id',
                                    scale: 'title'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    routingVersionCard: {
        entity: 'routingVersion',
        path: 'routingVersion',
        titleBar: { mergeParams: ['version'], new: 'routingVersion.form.new.title' },
        cardTitle: {
            title: 'routingVersion.form.dropdown.toggle',
            buttons: [
                {
                    type: 'submit',
                    id: 'routingVersionCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                { action: 'activate', label: 'routingVersion.form.activate', confirm: true, modalConfig: 'routingVersionConfirmActivate' },
                { action: 'retire', label: 'routingVersion.form.retire', confirm: true, modalConfig: 'routingVersionConfirmRetire' },
                { action: 'delete', label: 'routingVersion.form.delete', confirm: true, modalConfig: 'routingVersionConfirmDelete' }
            ],
            actions: {
                activate: { message: 'routingVersion.action.activate.message' },
                retire: { message: 'routingVersion.action.retire.message' }
            }
        },
        width: '900px',
        sections: [
            {
                id: 'routingVersion',
                meta: { type: 'form', width: '900px' },
                groups: [
                    {
                        type: 'group',
                        id: 'versionStatus',
                        fields: [
                            { type: 'text', id: 'version', label: 'routingVersion.form.version', placeholder: 'routingVersion.form.version.placeholder', required: true },
                            {
                                type: 'switchSelect',
                                id: 'status',
                                displayField: 'statusName',
                                label: 'routingVersion.form.status',
                                entity: 'activeStatus',
                                valueMap: {
                                    'statusName': 'name',
                                    'status': 'id'
                                },
                                readOnly: true
                            }
                        ]
                    },
                    {
                        type: 'dualconnect',
                        id: 'productId',
                        displayField: 'productName',
                        label: 'routingVersion.form.bomVersion',
                        placeholder: 'routingVersion.form.product.placeholder',
                        modalTitle: 'routingVersion.form.product.modal.title',
                        entity: 'product',
                        valueMap: {
                            'productId': 'id',
                            'productName': 'name',
                            'productSku': 'sku',
                        },
                        options: { withHeaders: false },
                        required: true,
                        sub: {
                            id: 'bomVersionId',
                            displayField: 'bomVersionName',
                            placeholder: 'routingVersion.form.bomVersion.name.placeholder',
                            modalTitle: 'routingVersion.form.bomVersion.modal.title',
                            entity: 'bomVersion',
                            valueMap: {
                                'bomVersionId': 'id',
                                'bomVersionName': 'version'
                            },
                            listDisplay: 'version'
                        }
                    },
                    {
                        type: 'group',
                        id: 'effectiveFromTo',
                        fields: [
                            { type: 'date', id: 'effectiveFrom', label: 'routingVersion.form.effectiveFrom', defaultType: 'date' },
                            { type: 'date', id: 'effectiveTo', label: 'routingVersion.form.effectiveTo', defaultType: 'date' }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'routingVersionCard.routingVersion.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'version',
                    columns: [
                        {
                            weight: 1, basis: '100%',
                            elements: [
                                { type: 'field', value: 'version', scale: 'title' },
                                { type: 'field', value: 'statusName', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 1, basis: '100%',
                            elements: [
                                { type: 'field', value: 'code', scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'routingVersion.operations',
                meta: {
                    type: 'lines',
                    linesArray: 'operations',
                    linesAddAction: 'routingVersion.form.operation.add',
                    width: '900px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'sequenceName',
                        fields: [
                            {
                                type: 'number',
                                id: 'sequence',
                                label: 'routingVersion.form.operation.sequence',
                                required: true,
                                decimals: 0,
                                defaultType: 'value',
                                defaultValue: 10,
                                variant: 'quantity'
                            },
                            {
                                type: 'text',
                                id: 'name',
                                label: 'routingVersion.form.operation.name',
                                placeholder: 'routingVersion.form.operation.name.placeholder'
                            }
                        ]
                    },
                    {
                        type: 'connect',
                        id: 'workCapabilityId',
                        displayField: 'workCapabilityName',
                        label: 'routingVersion.form.operation.workCapability',
                        placeholder: 'routingVersion.form.operation.workCapability.placeholder',
                        modalTitle: 'routingVersion.form.operation.workCapability.modal.title',
                        entity: 'workCapability',
                        valueMap: {
                            'workCapabilityId': 'id',
                            'workCapabilityName': 'name',
                            'workCapabilityCode': 'code'
                        },
                        options: { withHeaders: true },
                        required: true
                    },
                    {
                        type: 'group',
                        id: 'standardSetupRunTime',
                        fields: [
                            { type: 'number', id: 'standardSetupTime', label: 'routingVersion.form.operation.setupTime', decimals: 2, defaultValue: 0, variant: 'quantity' },
                            { type: 'number', id: 'standardRunTime', label: 'routingVersion.form.operation.runTime', decimals: 2, defaultValue: 0, variant: 'quantity' }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'queueMoveTime',
                        fields: [
                            { type: 'number', id: 'queueTime', label: 'routingVersion.form.operation.queueTime', decimals: 2, defaultValue: 0, variant: 'quantity' },
                            { type: 'number', id: 'moveTime', label: 'routingVersion.form.operation.moveTime', decimals: 2, defaultValue: 0, variant: 'quantity' }
                        ]
                    },
                    {
                        type: "modal",
                        id: 'routingVersionBomInputs',
                        label: "routingVersion.form.operation.inputs",
                        condition: { field: '$mode', operator: 'equals', value: 'edit' },
                        control: {
                            type: "text",
                            id: "inputsModal",
                            label: "routingVersion.form.operation.inputs",
                            placeholder: "routingVersion.form.operation.inputs.placeholder"
                        },
                        descriptions: [
                            { type: "field", field: "inputsCount" }
                        ],
                        modalFormRef: 'routingVersionBomInputs'
                    },
                    {
                        type: 'documentPicker',
                        id: 'documents',
                        label: 'routingVersion.form.operation.documents',
                        drawerTitle: 'routingVersion.form.operation.documents.drawer.title',
                        addLabel: 'routingVersion.form.operation.documents.add',
                        condition: { field: '$mode', operator: 'equals', value: 'edit' }
                    }
                ],
                buttons: [
                    { type: 'button', id: 'routingVersionCard.operations.delete', action: 'delete', label: 'all.form.button.delete', icon: 'delete', variant: 'danger', size: 'icon' },
                    { type: 'button', id: 'routingVersionCard.operations.close', action: 'close', label: 'all.form.button.save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'workCapabilityName',
                    emptyMessage: 'routingVersion.form.operation.missing',
                    editButtonRightOffset: '30%',
                    columns: [
                        { weight: 1, basis: '10%', elements: [{ type: 'field', value: 'sequence', scale: 'normal' }] },
                        { weight: 3, basis: '30%', elements: [{ type: 'field', value: 'name', scale: 'title' }, { type: 'field', value: 'workCapabilityName', scale: 'normal' }] },
                        { weight: 2, basis: '20%', elements: [{ type: 'merge', value: '${1} / ${2}', mergeParams: ['standardSetupTime', 'standardRunTime'], scale: 'normal' }] },
                        { weight: 1, basis: '10%', elements: [{ type: 'field', value: 'inputsCount', scale: 'normal' }] }
                    ]
                }
            }
        ]
    },

    stockAdjustmentCard: {
        entity: 'stockAdjustment',
        path: 'stockAdjustment',
        titleBar: { mergeParams: ['number'], new: 'inventory.adjustment.form.title.new' },
        cardTitle: {
            title: 'rack.form.dropdown.toggle',
            buttons: [
                {
                    type: 'submit',
                    id: 'stockAdjustmentCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'book',
                    label: 'all.menu.item.book',
                    confirm: false,
                    preflight: true,
                    modalConfig: 'confirmBook',
                    modalPreflight: 'preBook'
                }
            ],
            actions: {
                book: { message: 'inventory.adjustment.action.book.message' }
            }
        },
        afterSubmit: { navigateTo: '/inventory/adjustment' },
        sections: [
            {
                id: 'stockAdjustment.header',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'note',
                        fields: [
                            {
                                type: 'group',
                                direction: 'column',
                                fields: [
                                    {
                                        type: 'nserie',
                                        id: 'number',
                                        label: 'inventory.adjustment.form.numberAndDate',
                                        placeholder: 'inventory.adjustment.form.number.placeholder',
                                        entity: 'stockAdjustment',
                                        required: true,
                                        defaultType: 'nserie'
                                    },
                                    {
                                        type: 'date',
                                        id: 'date',
                                        placeholder: 'inventory.adjustment.form.date.placeholder',
                                        required: true,
                                        defaultType: 'date',
                                        align: 'right',
                                    },

                                ]
                            },
                            {
                                type: 'textarea',
                                id: 'note',
                                label: 'inventory.adjustment.form.note',
                                placeholder: 'inventory.adjustment.form.note.placeholder',
                                rows: 3
                            }
                        ]
                    }
                ],
                buttons: [
                ],
                displaySection: {
                    emptyField: 'id',
                    emptyMessage: 'rack.form.name.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '30%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title'
                                },
                                { type: 'date', value: 'date', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 2,
                            basis: '70%',
                            elements: [
                                { type: 'field', value: 'note', scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'stockAdjustment.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'inventory.adjustment.form.line.add.item',
                    width: '1024px',
                },
                groups: [
                    {

                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'inventory.adjustment.form.line.itemName',
                        placeholder: 'inventory.adjustment.form.line.itemName.placeholder',
                        modalTitle: 'inventory.adjustment.form.item.modal.title',
                        entity: 'product',
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemDescription': 'description',
                            'unitId': 'unitId',
                            'unitName': 'unitName',
                        },
                        options: { withHeaders: true },
                        required: true,
                        persistValue: true
                    },
                    {
                        type: 'text-readOnly',
                        id: 'itemDescription',
                        label: 'inventory.adjustment.form.line.itemDescription',
                        placeholder: 'inventory.adjustment.form.line.itemDescription.placeholder',
                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'quantityUnitId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'quantity',
                                label: 'inventory.adjustment.form.line.quantity',
                                placeholder: 'inventory.adjustment.form.line.quantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'inventory.adjustment.form.line.unitName',
                                placeholder: 'inventory.adjustment.form.line.unitName.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'unitName': 'name',
                                    'unitId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true
                            }
                        ]
                    },
                    {
                        type: 'connect',
                        id: 'locationId',
                        displayField: 'locationId',
                        label: 'inventory.adjustment.form.line.locationId',
                        placeholder: 'inventory.adjustment.form.line.locationId.placeholder',
                        modalTitle: 'inventory.adjustment.form.location.modal.title',
                        entity: 'location',
                        valueMap: {
                            'locationId': 'id',
                            'warehouseId': 'warehouseId',
                            'warehouseCode': 'warehouseCode',
                            'hallId': 'hallId',
                            'hallCode': 'hallCode',
                            'rackId': 'rackId',
                            'rackCode': 'rackCode',
                            'level': 'level',
                            'position': 'position'
                        },
                        options: { withHeaders: false },
                        menuItemField: 'id',
                        required: true,
                        modalType: 'radioGroup',
                        persistValue: true,
                        radioGroups: [
                            {
                                id: 'warehouse',
                                title: 'inventory.adjustment.form.location.modal.warehouse',
                                entity: 'warehouse',
                                valueField: 'code',
                                idPrefix: 'W',
                                labelField: 'code',
                                icon: 'warehouse',
                                iconField: 'warehouseTypeId',
                                iconMap: { PRODUCTION: 'factory', STORAGE: 'warehouse' }
                            },
                            {
                                id: 'hall',
                                title: 'inventory.adjustment.form.location.modal.hall',
                                entity: 'warehouse/:id/hall',
                                dependsOn: 'warehouse', // Specifies which group's value to use for :id
                                valueField: 'code',
                                labelField: 'code',
                                idPrefix: 'H',
                                icon: 'hall'
                            },
                            {
                                id: 'rack',
                                title: 'inventory.adjustment.form.location.modal.rack',
                                entity: 'rack',
                                dependsOn: 'warehouse',
                                valueField: 'code',
                                labelField: 'code',
                                idPrefix: 'R',
                                columns: 6,
                                filter: [
                                    { param: 'warehouseCode', groupId: 'warehouse' },
                                    { param: 'hallCode', groupId: 'hall' }
                                ],
                                subRadio: [
                                    { id: 'level', idPrefix: 'L', valueField: 'totalLevels', title: 'inventory.adjustment.form.location.modal.level', columns: 6, value: 'auto', optional: true },
                                    { id: 'position', idPrefix: 'P', valueField: 'totalPositions', title: 'inventory.adjustment.form.location.modal.position', columns: 6, value: 'auto' }
                                ],
                            }
                        ]
                    },
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'stockAdjustmentCard.lines.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'stockAdjustmentCard.lines.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'inventory.adjustment.form.line.missing.message',
                    editButtonRightOffset: '25%',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1}',
                                    mergeParams: ['itemName'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'locationId',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'quantity',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'unitName',
                                    scale: 'normal'
                                }
                            ],
                        }
                    ]
                }
            },
        ]
    },

    stockMovementCard: {
        entity: 'stockMovement',
        path: 'stockMovement',
        titleBar: { mergeParams: ['number'], new: 'inventory.movement.form.title.new' },
        cardTitle: {
            title: 'rack.form.dropdown.toggle',
            buttons: [
                {
                    type: 'submit',
                    id: 'stockMovementCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'book',
                    label: 'all.menu.item.book',
                    confirm: false,
                    preflight: true,
                    modalConfig: 'confirmBook',
                    modalPreflight: 'preBook'
                }
            ],
            actions: {
                book: { message: 'inventory.movement.action.book.message' }
            }
        },
        sections: [
            {
                id: 'stockMovement.header',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'note',
                        fields: [
                            {
                                type: 'group',
                                direction: 'column',
                                fields: [
                                    {
                                        type: 'nserie',
                                        id: 'number',
                                        label: 'inventory.movement.form.numberAndDate',
                                        placeholder: 'inventory.movement.form.number.placeholder',
                                        entity: 'stockAdjustment',
                                        required: true,
                                        defaultType: 'nserie'
                                    },
                                    {
                                        type: 'date',
                                        id: 'date',
                                        placeholder: 'inventory.movement.form.date.placeholder',
                                        required: true,
                                        defaultType: 'date',
                                        align: 'right',
                                    },

                                ]
                            },
                            {
                                type: 'textarea',
                                id: 'note',
                                label: 'inventory.movement.form.note',
                                placeholder: 'inventory.movement.form.note.placeholder',
                                rows: 3
                            }
                        ]
                    }
                ],
                buttons: [
                ],
                displaySection: {
                    emptyField: 'id',
                    emptyMessage: 'rack.form.name.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '30%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title'
                                },
                                { type: 'date', value: 'date', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 2,
                            basis: '70%',
                            elements: [
                                { type: 'field', value: 'note', scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'stockMovement.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'inventory.movement.form.line.add.item',
                    width: '1024px',
                },
                groups: [
                    {

                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'inventory.movement.form.line.itemName',
                        placeholder: 'inventory.movement.form.line.itemName.placeholder',
                        modalTitle: 'inventory.movement.form.item.modal.title',
                        entity: 'product',
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemDescription': 'description',
                            'unitId': 'unitId',
                            'unitName': 'unitName',
                        },
                        options: { withHeaders: true },
                        required: true
                    },
                    {
                        type: 'text-readOnly',
                        id: 'itemDescription',
                        label: 'inventory.movement.form.line.itemDescription',
                        placeholder: 'inventory.movement.form.line.itemDescription.placeholder',
                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'quantityUnitId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'quantity',
                                label: 'inventory.movement.form.line.quantity',
                                placeholder: 'inventory.movement.form.line.quantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'inventory.movement.form.line.unitName',
                                placeholder: 'inventory.movement.form.line.unitName.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'unitName': 'name',
                                    'unitId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'locationId',
                        fields: [
                            {
                                type: "modal",
                                id: 'locationId',
                                subObject: 'origin',
                                emptyMessage: "inventory.movement.form.line.fromLocation.empty",
                                disableOnMissing: 'itemId',
                                control: {
                                    type: "text",
                                    id: "locationsModal",
                                    label: "inventory.movement.form.line.fromLocation",
                                    placeholder: "inventory.shipment.form.lines.location.placeholder"
                                },
                                descriptions: [
                                    {
                                        type: "field",
                                        field: "locationId",
                                    }
                                ],
                                modalFormRef: 'selectFromLocation'
                            },
                            {
                                type: 'connect',
                                id: 'locationId',
                                displayField: 'locationId',
                                subObject: 'destination',
                                label: 'inventory.movement.form.line.toLocation',
                                placeholder: 'inventory.movement.form.line.locationId.placeholder',
                                modalTitle: 'inventory.movement.form.location.modal.title',
                                entity: 'location',
                                valueMap: {
                                    'locationId': 'id',
                                    'warehouseId': 'warehouseId',
                                    'warehouseCode': 'warehouseCode',
                                    'hallId': 'hallId',
                                    'hallCode': 'hallCode',
                                    'rackId': 'rackId',
                                    'rackCode': 'rackCode',
                                    'level': 'level',
                                    'position': 'position'
                                },
                                options: { withHeaders: false },
                                menuItemField: 'id',
                                required: true,
                                modalType: 'radioGroup',
                                persistValue: true,
                                radioGroups: [
                                    {
                                        id: 'warehouse',
                                        title: 'inventory.movement.form.location.modal.warehouse',
                                        entity: 'warehouse',
                                        valueField: 'code',
                                        idPrefix: 'W',
                                        labelField: 'code',
                                        icon: 'warehouse',
                                        iconField: 'warehouseTypeId',
                                        iconMap: { PRODUCTION: 'factory', STORAGE: 'warehouse' }
                                    },
                                    {
                                        id: 'hall',
                                        title: 'inventory.movement.form.location.modal.hall',
                                        entity: 'warehouse/:id/hall',
                                        dependsOn: 'warehouse', // Specifies which group's value to use for :id
                                        valueField: 'code',
                                        labelField: 'code',
                                        idPrefix: 'H',
                                        icon: 'hall'
                                    },
                                    {
                                        id: 'rack',
                                        title: 'inventory.movement.form.location.modal.rack',
                                        entity: 'rack',
                                        dependsOn: 'warehouse',
                                        valueField: 'code',
                                        labelField: 'code',
                                        idPrefix: 'R',
                                        columns: 6,
                                        filter: [
                                            { param: 'warehouseCode', groupId: 'warehouse' },
                                            { param: 'hallCode', groupId: 'hall' }
                                        ],
                                        subRadio: [
                                            { id: 'level', idPrefix: 'L', valueField: 'totalLevels', title: 'inventory.movement.form.location.modal.level', columns: 6, value: 'auto', optional: true },
                                            { id: 'position', idPrefix: 'P', valueField: 'totalPositions', title: 'inventory.movement.form.location.modal.position', columns: 6, value: 'auto' }
                                        ],
                                    }
                                ]
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'stockMovementCard.lines.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'stockMovementCard.lines.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'inventory.movement.form.line.missing.message',
                    editButtonRightOffset: '25%',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1}',
                                    mergeParams: ['itemName'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'locationId',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'quantity',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'unitName',
                                    scale: 'normal'
                                }
                            ],
                        }
                    ]
                }
            },
        ]
    },

    stockReceiptCard: {
        entity: 'stockReceipt',
        path: 'stockReceipt',
        titleBar: { mergeParams: ['number'], new: 'inventory.receipt.form.title.new' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    type: 'submit',
                    id: 'stockReceiptCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false,
                    invalidateQuery: 'stockReceipt'
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'book',
                    label: 'all.menu.item.book',
                    confirm: false,
                    preflight: true,
                    modalConfig: 'confirmBook',
                    modalPreflight: 'preBook'
                }
            ],
            actions: {
                book: { message: 'inventory.receipt.action.book.message' }
            }
        },
        width: '',
        afterSubmit: { navigateTo: '/inventory/receipt' },
        sections: [
            {
                id: 'receipt.number',
                meta: {
                    type: 'form',
                    width: '1200px',
                },
                groups: [
                    {
                        type: 'group',
                        id: 'numberDate',
                        fields: [
                            {
                                type: 'nserie',
                                id: 'number',
                                label: 'inventory.receipt.form.number',
                                placeholder: 'inventory.receipt.form.number.placeholder',
                                entity: 'stockReceipt',
                                required: true,
                                defaultType: 'nserie'
                            },
                            {
                                type: 'date',
                                id: 'date',
                                label: 'inventory.receipt.form.date',
                                placeholder: 'inventory.receipt.form.date.placeholder',
                                required: true,
                                defaultType: 'date',
                                align: 'right'
                            },
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'note',
                        label: 'inventory.receipt.form.note',
                        placeholder: 'inventory.receipt.form.note.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'stockReceiptCard.number.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'number',
                    emptyMessage: 'inventory.receipt.form.number.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'inventory.receipt.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'receipt.supplier',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'connect',
                        id: 'supplierId',
                        displayField: 'supplierName',
                        label: 'inventory.receipt.form.supplier',
                        placeholder: 'inventory.receipt.form.supplier.placeholder',
                        modalTitle: 'inventory.receipt.form.supplier.modal.title',
                        entity: 'contact',
                        entityParams: {
                            type: 'filter',
                            filters: [{ key: 'contactType', value: 'supplier|both' }]
                        },
                        valueMap: {
                            'supplierId': 'id',
                            'supplierName': 'name',
                            'supplierAddress_street': 'address_street',
                            'supplierAddress_postCode': 'address_postCode',
                            'supplierAddress_city': 'address_city',
                            'supplierCountry': 'country',
                            'supplierCountryName': 'countryName'
                        },
                        options: { withHeaders: false },
                        required: true
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'stockReceiptCard.supplier.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'supplierName',
                    emptyMessage: 'inventory.receipt.form.supplier.missing.message',
                    editButtonRightOffset: '10%',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'supplierName',
                                    scale: 'title',
                                    icon: 'people'
                                },
                                {
                                    type: 'field',
                                    value: 'linkedDocumentNumber',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'receipt.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'inventory.receipt.form.line.add.item',
                    warning: { field: 'locationId', compareField: '${notEmpty}' },
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'product.form.itemName',
                        placeholder: 'product.form.itemName.placeholder',
                        modalTitle: 'product.form.item.modal.title',
                        entity: 'product',
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemDescription': 'description',
                            'unitId': 'unitId',
                            'unitName': 'unitName',
                        },
                        options: { withHeaders: true },
                        required: true
                    },
                    {
                        type: 'textarea',
                        id: 'itemDescription',
                        label: 'product.form.itemDescription',
                        placeholder: 'product.form.itemDescription.placeholder',
                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'itemQuantityUnitId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'itemQuantity',
                                label: 'product.form.itemQuantity',
                                placeholder: 'product.form.itemQuantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'product.form.unitName',
                                placeholder: 'product.form.unitName.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'unitName': 'name',
                                    'unitId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true
                            }
                        ]
                    },
                    {
                        type: 'connect',
                        id: 'locationId',
                        displayField: 'locationId',
                        label: 'inventory.receipt.form.line.locationId',
                        placeholder: 'inventory.receipt.form.line.locationId.placeholder',
                        modalTitle: 'inventory.receipt.form.location.modal.title',
                        entity: 'location',
                        valueMap: {
                            'locationId': 'id',
                            'warehouseId': 'warehouseId',
                            'warehouseCode': 'warehouseCode',
                            'hallId': 'hallId',
                            'hallCode': 'hallCode',
                            'rackId': 'rackId',
                            'rackCode': 'rackCode',
                            'level': 'level',
                            'position': 'position'
                        },
                        options: { withHeaders: false },
                        menuItemField: 'id',
                        required: true,
                        modalType: 'radioGroup',
                        persistValue: true,
                        radioGroups: [
                            {
                                id: 'warehouse',
                                title: 'inventory.adjustment.form.location.modal.warehouse',
                                entity: 'warehouse',
                                valueField: 'code',
                                idPrefix: 'W',
                                labelField: 'code',
                                icon: 'warehouse',
                                iconField: 'warehouseTypeId',
                                iconMap: { PRODUCTION: 'factory', STORAGE: 'warehouse' }
                            },
                            {
                                id: 'hall',
                                title: 'inventory.adjustment.form.location.modal.hall',
                                entity: 'warehouse/:id/hall',
                                dependsOn: 'warehouse',
                                valueField: 'code',
                                labelField: 'code',
                                idPrefix: 'H',
                                icon: 'hall'
                            },
                            {
                                id: 'rack',
                                title: 'inventory.adjustment.form.location.modal.rack',
                                entity: 'rack',
                                dependsOn: 'warehouse',
                                valueField: 'code',
                                labelField: 'code',
                                idPrefix: 'R',
                                columns: 6,
                                filter: [
                                    { param: 'warehouseCode', groupId: 'warehouse' },
                                    { param: 'hallCode', groupId: 'hall' }
                                ],
                                subRadio: [
                                    { id: 'level', idPrefix: 'L', valueField: 'totalLevels', title: 'inventory.adjustment.form.location.modal.level', columns: 6, value: 'auto', optional: true },
                                    { id: 'position', idPrefix: 'P', valueField: 'totalPositions', title: 'inventory.adjustment.form.location.modal.position', columns: 6, value: 'auto' }
                                ],
                            }
                        ]
                    },
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'stockReceiptCard.lines.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'stockReceiptCard.lines.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'product.form.product.missing.message',
                    editButtonRightOffset: '25%',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'itemQuantity',
                                    scale: 'title'
                                },
                                {
                                    type: 'unitName',
                                    value: 'unitName',
                                    scale: 'normal'
                                }
                            ],
                        }
                    ]
                },
            },
            {
                id: 'receipt.summary',
                meta: {
                    type: 'totals',
                    collapsible: false,
                    width: '1200px',
                    align: 'end',
                    variant: 'transparent'
                },
                displaySection: {
                    elements: [
                        {
                            type: 'line',
                            value: 'totalProducts',
                            scale: 'large',
                            label: 'inventory.receipt.total.products'
                        }
                    ]
                }
            },
        ]
    },

    stockShipmentCard: {
        entity: 'stockShipment',
        path: 'stockShipment',
        titleBar: { mergeParams: ['number'], new: 'inventory.shipment.form.title.new' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    type: 'submit',
                    id: 'stockShipmentCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false,
                    invalidateQuery: 'stockShipment'
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'book',
                    label: 'all.menu.item.book',
                    confirm: false,
                    preflight: true,
                    modalConfig: 'confirmBook',
                    modalPreflight: 'preBook'
                }
            ],
            actions: {
                book: { message: 'inventory.shipment.action.book.message' }
            }

        },
        width: '',
        afterSubmit: { navigateTo: '/inventory/shipment' },
        fieldsLogic: ['paymentTermId', 'date', 'paymentDate'],
        defaultData: [
            {
                id: 'font',
                defaultType: 'value',
                defaultValue: 'Courier',
            }
        ],
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'stockShipment',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'inventory.shipment.form.mobile.panel.reservation',
                            action: 'showModal',
                            icon: 'lock',
                            modalFormRef: 'inventoryShipmentReservations'
                        },
                        {
                            type: 'modal',
                            title: 'inventory.shipment.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'inventoryShipmentDesign'
                        }
                    ]
                }
            ]
        },
        sections: [
            {
                id: 'shipment.number',
                meta: {
                    type: 'form',
                    width: '1200px',
                },
                groups: [
                    {
                        type: 'group',
                        id: 'numberDate',
                        fields: [
                            {
                                type: 'nserie',
                                id: 'number',
                                label: 'inventory.shipment.form.number',
                                placeholder: 'inventory.shipment.form.number.placeholder',
                                entity: 'stockShipment',
                                required: true,
                                defaultType: 'nserie'
                            },
                            {
                                type: 'date',
                                id: 'date',
                                label: 'inventory.shipment.form.date',
                                placeholder: 'inventory.shipment.form.date.placeholder',
                                required: true,
                                defaultType: 'date',
                                align: 'right'
                            },
                        ]
                    },
                    {
                        type: 'group',
                        id: 'id',
                        fields: [
                            {
                                type: 'connect',
                                id: 'id',
                                displayField: 'name',
                                subObject: 'warehouse',
                                label: 'inventory.shipment.form.warehouse',
                                modalTitle: 'inventory.shipment.form.warehouse.modal.title',
                                entity: 'warehouse',
                                valueMap: {
                                    'name': 'name',
                                    'id': 'id',
                                    'code': 'code',
                                    'address_name': 'address_name',
                                    'address_street': 'address_street',
                                    'address_postCode': 'address_postCode',
                                    'address_city': 'address_city',
                                    'address_region': 'address_region',
                                    'aountry': 'country',
                                    'countryName': 'countryName',
                                },
                                options: { withHeaders: false },
                                required: true,
                                showSubField: { field: 'warehouseUseHalls', value: true }
                            }, {}
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'message',
                        label: 'inventory.shipment.form.message',
                        placeholder: 'inventory.shipment.form.message.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'stockShipmentCard.number.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'number',
                    emptyMessage: 'inventory.shipment.form.number.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'inventory.shipment.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'shipment.customer',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'dualconnect',
                        id: 'customerId',
                        displayField: 'customerName',
                        label: 'customer.form.customerName',
                        placeholder: 'customer.form.customerName.placeholder',
                        modalTitle: 'customer.form.customer.modal.title',
                        entity: 'contact',
                        entityParams: { type: 'filter', filters: [{ key: 'contactType', value: 'customer|both|undefined' }] },
                        valueMap: {
                            'customerName': 'name',
                            'customerId': 'id',
                            'customerEmail': 'email',
                            'customerAddress_city': 'address_city',
                            'customerAddress_postCode': 'address_postCode',
                            'customerAddress_street': 'address_street',
                            'customerCountry': 'country',
                            'customerCountryName': 'countryName',
                            'companyTypeId': 'companyTypeId'
                        },
                        options: { withHeaders: false },
                        required: true,
                        showSubField: { field: 'companyTypeId', value: 'company' },
                        sub: {
                            id: 'contactPersonId',
                            displayField: 'contactPersonName',
                            placeholder: 'customer.form.contactPerson.name.placeholder',
                            modalTitle: 'customer.form.contactPerson.modal.title',
                            entity: 'contactPerson',
                            valueMap: {
                                'contactPersonName': 'name',
                                'contactPersonId': 'id',
                                'customerEmail': 'email'
                            }
                        }
                    },
                    {
                        type: 'email',
                        id: 'customerEmail',
                        label: 'customer.form.customerEmail',
                        placeholder: 'customer.form.customerEmail.placeholder',
                        required: true
                    },
                    {
                        type: 'text',
                        id: 'customerAddress_street',
                        label: 'customer.form.customerAddress',
                        placeholder: 'customer.form.customerAddress.street',
                        autoComplete: 'address-line1'
                    },
                    {
                        type: 'group',
                        id: 'customerAddressPostCodeCity',
                        focus: false,
                        fields: [
                            {
                                type: 'text',
                                id: 'customerAddress_postCode',
                                placeholder: 'customer.form.customerAddress.postcode',
                                autoComplete: 'postal-code'
                            },
                            {
                                type: 'text',
                                id: 'customerAddress_city',
                                placeholder: 'customer.form.customerAddress.city',
                                focus: false,
                                autoComplete: 'address-level2'
                            },

                        ]
                    },
                    {
                        type: 'country',
                        id: 'customerCountry',
                        displayField: 'customerCountryName',
                        placeholder: 'customer.form.customerCountry',
                        valueMap: {
                            'customerCountry': 'id',
                            'customerCountryName': 'name',
                        },
                        defaultType: 'country',
                        fgMargin: '1.5rem'
                    },

                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'stockShipmentCard.customer.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'customerName',
                    emptyMessage: 'customer.form.customer.missing.message',
                    editButtonRightOffset: '10%',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'customerName',
                                    scale: 'title',
                                    icon: 'people'
                                },
                                {
                                    type: 'field',
                                    value: 'customerEmail',
                                    scale: 'normal'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['customerAddress_street', 'customerAddress_postCode', 'customerAddress_city', 'customerCountryName'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'shipment.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'inventory.shipment.form.line.add.item',
                    preventDelete: { field: 'reservedQuantity', message: 'inventory.shipment.line.prevent.delete' },
                    warning: { field: 'allocatedQuantity', compareField: 'itemQuantity' },

                    width: '1200px'
                },
                init: [
                    {
                        type: 'number',
                        id: 'allocatedQuantity',
                        defaultType: 'value',
                        defaultValue: 0,
                    },
                ],
                groups: [
                    {

                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'product.form.itemName',
                        placeholder: 'product.form.itemName.placeholder',
                        modalTitle: 'product.form.item.modal.title',
                        entity: 'product',
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemDescription': 'description',
                            'unitId': 'unitId',
                            'unitName': 'unitName',
                        },
                        options: { withHeaders: true },
                        required: true
                    },
                    {
                        type: 'textarea',
                        id: 'itemDescription',
                        label: 'product.form.itemDescription',
                        placeholder: 'product.form.itemDescription.placeholder',
                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'itemQuantityUnitId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'itemQuantity',
                                label: 'product.form.itemQuantity',
                                placeholder: 'product.form.itemQuantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'product.form.unitName',
                                placeholder: 'product.form.unitName.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'unitName': 'name',
                                    'unitId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true
                            }
                        ]
                    },
                    {
                        type: "modal",
                        id: 'selectLocations',
                        label: "inventory.shipment.form.lines.locations.label",
                        validation: {
                            "field": "itemQuantity",
                            "operator": "equals",
                            "value": "allocatedQuantity",
                        },
                        condition: { field: '$mode', operator: 'equals', value: 'edit' },
                        onSave: {
                            invalidateQuery: 'stockShipment'
                        },
                        control: {
                            type: "text",
                            id: "locationsModal",
                            label: "inventory.shipment.form.lines.location",
                            placeholder: "inventory.shipment.form.lines.location.placeholder"
                        },
                        descriptions: [
                            {
                                type: "label",
                                text: "inventory.shipment.form.lines.location.quantity.allocated",
                            },
                            {
                                type: "text",
                                text: " ",
                            },
                            {
                                type: "field",
                                field: "allocatedQuantity",
                            }
                        ],
                        modalFormRef: 'selectLocations'
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'stockShipmentCard.lines.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'stockShipmentCard.lines.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'product.form.product.missing.message',
                    editButtonRightOffset: '25%',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'itemQuantity',
                                    scale: 'title'
                                },
                                {
                                    type: 'unitName',
                                    value: 'unitName',
                                    scale: 'normal'
                                }
                            ],
                        }
                    ]
                }
            },
            {
                id: 'shipment.summary',
                meta: {
                    type: 'totals',
                    collapsible: false,
                    width: '1200px',
                    align: 'end',
                    variant: 'transparent'
                },
                displaySection: {
                    elements: [
                        {
                            type: 'line',
                            value: 'totalProducts',
                            scale: 'large',
                            label: 'inventory.shipment.total.products'
                        }
                    ]
                }
            },
            {
                id: 'shipment.terms',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'textarea',
                        id: 'terms',
                        label: 'inventory.shipment.form.terms',
                        placeholder: 'inventory.shipment.form.terms.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'stockShipmentCard.terms.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'terms',
                    emptyMessage: 'inventory.shipment.form.terms.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'invoice.form.terms',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'terms',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
        ]
    },

    supplierItemCard: {
        entity: 'supplierItem',
        path: 'product/:id/supplierItem',
        titleBar: { mergeParams: ['supplierName'], new: 'supplierItem.form.new.title' },
        cardTitle: {
            title: 'supplierItem.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'supplierItem.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        sections: [
            {
                id: 'supplierItem',
                meta: { type: 'form', width: '1024px' },
                groups: [
                    {
                        type: 'connect',
                        id: 'supplierId',
                        displayField: 'supplierName',
                        label: 'supplierItem.form.supplier',
                        placeholder: 'supplierItem.form.supplier.placeholder',
                        modalTitle: 'supplierItem.form.supplier.modal.title',
                        entity: 'contact',
                        entityParams: {
                            type: 'filter',
                            filters: [{ key: 'contactType', value: 'supplier|both' }]
                        },
                        valueMap: {
                            'supplierId': 'id',
                            'supplierName': 'name',
                            'supplierAddress_street': 'address_street',
                            'supplierAddress_postCode': 'address_postCode',
                            'supplierAddress_city': 'address_city',
                            'supplierCountry': 'country',
                            'supplierCountryName': 'countryName'
                        },
                        options: { withHeaders: true },
                        required: true
                    },
                    {
                        type: 'group',
                        id: 'supplierSkuBarcode',
                        fields: [
                            {
                                type: 'text',
                                id: 'supplierSku',
                                label: 'supplierItem.form.supplierSku',
                                placeholder: 'supplierItem.form.supplierSku.placeholder'
                            },
                            {
                                type: 'text',
                                id: 'barcode',
                                label: 'supplierItem.form.barcode',
                                placeholder: 'supplierItem.form.barcode.placeholder'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        id: 'name',
                        label: 'supplierItem.form.name',
                        placeholder: 'supplierItem.form.name.placeholder'
                    },
                    {
                        type: 'group',
                        id: 'purchaseUnitIdProductUnitIdConversionQuantity',
                        fields: [
                            {
                                type: 'select',
                                id: 'purchaseUnitId',
                                displayField: 'purchaseUnitName',
                                label: 'supplierItem.form.purchaseUnit',
                                placeholder: 'supplierItem.form.purchaseUnit.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'purchaseUnitName': 'name',
                                    'purchaseUnitId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true
                            },
                            {
                                type: 'select',
                                id: 'productUnitId',
                                displayField: 'productUnitName',
                                label: 'supplierItem.form.productUnit',
                                placeholder: 'supplierItem.form.productUnit.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'productUnitName': 'name',
                                    'productUnitId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true
                            },
                            {
                                type: 'number',
                                id: 'conversionQuantity',
                                label: 'supplierItem.form.conversionQuantity',
                                placeholder: 'supplierItem.form.conversionQuantity.placeholder',
                                required: true,
                                decimals: 4,
                                variant: 'quantity'
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'minimumOrderQuantityLeadTimeDays',
                        fields: [
                            {
                                type: 'number',
                                id: 'minimumOrderQuantity',
                                label: 'supplierItem.form.moq',
                                placeholder: 'supplierItem.form.moq.placeholder',
                                decimals: 0,
                                variant: 'quantity'
                            },
                            {
                                type: 'number',
                                id: 'leadTimeDays',
                                label: 'supplierItem.form.leadTimeDays',
                                placeholder: 'supplierItem.form.leadTimeDays.placeholder',
                                decimals: 0,
                                variant: 'quantity'
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'purchasePriceCurrency',
                        fields: [
                            {
                                type: 'number',
                                id: 'purchasePrice',
                                label: 'supplierItem.form.purchasePrice',
                                placeholder: 'supplierItem.form.purchasePrice.placeholder',
                                decimals: 4,
                                variant: 'amount'
                            },
                            {
                                type: 'currency',
                                id: 'currency',
                                displayField: 'currency',
                                label: 'supplierItem.form.currency',
                                placeholder: 'supplierItem.form.currency.placeholder',
                                modalTitle: 'supplierItem.form.currency.modal.title',
                                entity: 'currency',
                                valueMap: {
                                    'currency': 'id',
                                    'currencyName': 'name'
                                },
                                options: { withHeaders: false, displayId: true }
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'preferredActive',
                        fields: [
                            {
                                type: 'switch',
                                id: 'preferred',
                                label: 'supplierItem.form.preferred',
                                on: 'supplierItem.form.preferred.yes',
                                off: 'supplierItem.form.preferred.no'
                            },
                            {
                                type: 'switch',
                                id: 'active',
                                label: 'supplierItem.form.active',
                                on: 'supplierItem.form.active.yes',
                                off: 'supplierItem.form.active.no'
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'supplierItemCard.supplierItem.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'supplierName',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                { type: 'field', value: 'supplierName', scale: 'title' },
                                { type: 'field', value: 'supplierSku', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                { type: 'field', value: 'purchaseUnitName', scale: 'normal' },
                                { type: 'field', value: 'conversionQuantity', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },
}
